import { GameEvents } from '../GameEvents';
import { trackHintViewed } from '../analytics';
import type EventBus from '../EventBus';
import getLogger from '../logger';

const logger = getLogger('TutorialHandler');

// Asset manifest for tutorial images – moved from GameManager
import stumpyImg from '../../../assets/images/demented-stump.png';

const tutorialAssetManifest: Record<string, { url: string }> = {
  energy: { url: stumpyImg },
};

export default class TutorialHandler {
  private state: any;
  private slice: any;
  private eventBus: EventBus;

  constructor(state: any, slice: any, eventBus: EventBus) {
    this.state = state;
    this.slice = slice;
    this.eventBus = eventBus;

    this.eventBus.on(GameEvents.LEVEL_PREPARED, (payload: any) => this._onLevelPrepared(payload));
    this.eventBus.on(GameEvents.SHOW_TUTORIAL, () => this._onShowTutorial());
    this.eventBus.on(GameEvents.DISMISS_TUTORIAL, () => this._onDismissTutorial());
  }

  _onLevelPrepared({ levelKey, tutorial }: { levelKey: string; tutorial: any }) {
    // Store available tutorial for the "?" button
    this.slice.availableTutorial = tutorial || null;

    if (!tutorial) return;

    // Completed levels: never auto-show, but the "?" button and vision are unlocked
    const isCompleted = this.state.progress.completedLevelIds?.[levelKey];
    if (isCompleted) return;

    // Read progress for auto-show decision
    const levelState = this.state.progress.levelStates[levelKey] || { failures: 0, tutorialShown: false };
    const failureThreshold = tutorial.failures || 0;

    // Auto-show: failures >= threshold AND not already shown
    if (levelState.failures >= failureThreshold && !levelState.tutorialShown) {
      this.slice.currentTutorial = {
        text: tutorial.text,
        imageUrl: tutorial.image ? (tutorialAssetManifest[tutorial.image]?.url || null) : null,
      };

      // Persist tutorialShown flag
      this.eventBus.emit(GameEvents.SET_TUTORIAL_SHOWN, { levelKey });

      // Track automatic hint
      const attemptNumber = levelState.failures + 1;
      trackHintViewed(levelKey, attemptNumber, 'automatic');
    }
  }

  _onShowTutorial() {
    const levelKey = this.state.gameplay.currentLevelKey;
    const tutorial = this.slice.availableTutorial;
    if (!tutorial || !levelKey) return;

    // Allow manual show if tutorial has been auto-shown before, or if the level is already completed
    const levelState = this.state.progress.levelStates[levelKey];
    const isCompleted = this.state.progress.completedLevelIds?.[levelKey];
    if (!isCompleted && (!levelState || !levelState.tutorialShown)) return;

    this.slice.currentTutorial = {
      text: tutorial.text,
      imageUrl: tutorial.image ? (tutorialAssetManifest[tutorial.image]?.url || null) : null,
    };
  }

  _onDismissTutorial() {
    this.slice.currentTutorial = null;
  }
}
